import 'bootstrap-icons/font/bootstrap-icons.css';
import _ from 'underscore';

import dayjs from '../../../shared/services/dayjs.js';
import { initKeycloak } from '../../../shared/services/keycloakService.js';
import ApplicationLauncher from '../../../shared/services/applicationLauncher.js';
import SystemDialogService from '../../../shared/services/systemDialogService.js';
import basedataService from './services/basedataService.js';
import stammdatenService from './services/stammdatenService.js';
import systemNachrichtService from './services/systemNachrichtService.js';
import {
	convertNumberToEuro,
	displayArray,
	displayValues,
	erstelleMitarbeiterListe,
	filterListe,
	formatNumber2Decimals,
	fuelleBetriebSelect,
	fuelleSelectOptionen,
	getAktuellerZeitraum,
	getSelectedMitarbeiterIDs,
	hightlightMA,
	rejectAktionBeiArchivierteMA,
	resetDialogInput,
	setMenuActive,
	setMenuInactive,
	sperreOberflaeche,
	toggleLoader,
	updateAuswahlAnzahlMA,
	updateProgressbar,
	startChunkProgress,
	istEingeschraenkterSachbearbeiter,
	disableFormControls,
	zeigeFehlerFenster
} from './util.js';
import ValidationService from './services/validationService.js';
import { Roles } from '../../../../domain/konstanten/Roles.js';
import { buildCrumbs, fmtValue, resolveValue } from '../../../../common/functions/protokollHelper.js';
import { ladeBerichteMA, getZettelHTML } from './berichte.js';
import { ladeTagesuebersicht } from './tagesuebersicht.js';
// VW Daten Skript Imports
import { ladeVerwaltung } from './verwaltung/vw_stammdaten.js';
import { ladeEinsatzorte } from './verwaltung/vw_einsatzorte.js';
import { ladeSchriftverkehr } from './verwaltung/vw_schriftverkehr.js';
import { ladeBenutzerverwaltung } from './verwaltung/vw_benutzer.js';
import { ladeZeitregeln } from './verwaltung/vw_zeitregeln.js';
import { ladeAlleEinstellungen } from './verwaltung/vw_einstellungen.js';
import { ladeKrankenkassen } from './verwaltung/vw_krankenkassen.js';
// MA Daten Skript Imports
import { forceUpdateMA, neocheckerMitarbeiterFristen } from './mitarbeiter/ma_daten.js';
import { ladeUebersicht } from './mitarbeiter/ma_uebersicht.js';
import { ladePersonalien } from './mitarbeiter/ma_personalien.js';
import { ladeBeschaeftigung } from './mitarbeiter/ma_beschaeftigung.js';
import { ladeAbgaben } from './mitarbeiter/ma_abgaben.js';
import { ladeMALohnarten } from './mitarbeiter/ma_lohnarten.js';
import { ladeZuschlaege } from './mitarbeiter/ma_zuschlaege.js';
import { ladeZeitkonto } from './mitarbeiter/ma_egfz.js';
import zeitenScript from './mitarbeiter/ma_zeiten.js';
import { ladeMitarbeiterPostfach } from './mitarbeiter/ma_postfach.js';
import { ladeHistorie } from './mitarbeiter/ma_historie.js';
import { ladeLohnarten } from './verwaltung/vw_lohnarten.js';
import { ladeQualifikationen } from './verwaltung/vw_qualifikationen.js';
import { ladeBetriebsregeln } from './verwaltung/vw_betriebsregeln.js';
import { ladeRechnung } from './verwaltung/vw_rechnung.js';
import { ladeMonatsuebersicht } from './monatsuebersicht.js';
import { MindestlohnHistorie } from '../../../../domain/konstanten/Mindestlohn.js';
import { convertNumberDE } from '../../../dienstplan/frontend/js/util.js';
import NeoChecker from './services/neoChecker.js';
import dashboard from './dashboard/dashboard.js';

document.addEventListener('DOMContentLoaded', async () => {
	await initKeycloak();
});

const throttleWechsleMitarbeiter = _.throttle(wechsleMitarbeiter, 250);
// Zuletzt ausgewählter Mitarbeiter, wird beim Zurückwechseln auf den Mitarbeiter-Reiter wieder ausgewählt.
let letzteMitarbeiterID = null;

// globale Variablen, Event Handlers und Services bereitstellen...
window.myVars = window.myVars || {};
// Globale Variable, die aussagt, ob es aktuell Änderungen im Mitarbeiter gibt.
window.myVars.mitarbeiterEditiert = false;
window.myVars.lastDebounceId = -1;
window.myVars.neocheckerDebounceId = -1;
// sortDokumentType 0: A-Z, 1: Z-A, 2: recent -> old 3: old -> recent
window.myVars.sortDokumentType = 0;
// pop up fenster Referenz.
window.myVars.popUpBericht;
window.myHandlers = window.myHandlers || {};
window.myServices = window.myServices || {};
window.myHandlers.resetHome = resetHome;
window.myHandlers.openRechnungen = openRechnungen;
window.myHandlers.wechsleBetrieb = wechsleBetrieb;
window.myHandlers.monatsWechselPick = monatsWechselPick;
window.myHandlers.monatsWechselEvent = monatsWechselEvent;
window.myHandlers.wechsleMitarbeiter = throttleWechsleMitarbeiter;
window.myHandlers.topmenuClick = topmenuClick;
window.myHandlers.submenuClick = submenuClick;
window.myHandlers.maNeuClick = maNeuClick;
window.myHandlers.maLohnabrechnungClick = maLohnabrechnungClick;
window.myHandlers.confirmMaNeuDialog = confirmMaNeuDialog;
window.myHandlers.berechnenMA = berechnenMA;
window.myHandlers.exportMA = exportMA;
window.myHandlers.malistClick = malistClick;
window.myHandlers.toggleAccordion = toggleAccordion;
window.myHandlers.showErrorsMA = showErrorsMA;
window.myHandlers.showAbweichungMA = showAbweichungMA;
window.myHandlers.showErrorsUnternehmen = showErrorsUnternehmen;
window.myHandlers.selectMA = selectMA;
window.myHandlers.markMA = markMA;
window.myHandlers.monatEntsperrenMA = monatEntsperrenMA;
window.myHandlers.toggleSFNResults = toggleSFNResults;
window.myHandlers.nachrichtenButtonClick = nachrichtenButtonClick;

window.myServices.maValidationService = new ValidationService('/neolohn/api/mitarbeiter/id/update/validate');
window.myServices.dashboard = dashboard;

ApplicationLauncher.instance.pushEventListener(async () => {
	// the event occurred
	toggleLoader();
	// window.myVars.aktuellesMonatsDatum und window.myVars.websiteStatus ist in window.myVars definiert
	window.myVars.websiteStatus = 'home';

	const clock = document.getElementById('neolohn-clock');
	setInterval(() => { clock.innerHTML = `
		<div>${dayjs().tz().format('HH:mm:ss')}</div>
		<div>${dayjs().tz().format('DD.MM.YYYY')}</div>
		`;
	}, 500);
	// Rollenspezifisches ausblenden von html elementen.
	const hasModRole =
        window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget) ||
        window.myVars.UserRoles.includes(Roles.DienstplanerOhneBudget) ||
        window.myVars.UserRoles.includes(Roles.Zeitenpfleger);
	window.myVars.HideMod = hasModRole && !window.myVars.UserRoles.includes(Roles.Sachbearbeiter);
	const hasFullModAccess =
		window.myVars.UserRoles.includes(Roles.Sachbearbeiter) ||
		window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget) ||
		window.myVars.UserRoles.includes(Roles.DienstplanerOhneBudget);
	window.myVars.HideMod2 = window.myVars.UserRoles.includes(Roles.Zeitenpfleger) && !hasFullModAccess;
	if (window.myVars.HideMod) {
		const styleElement = document.createElement('style');
		document.head.appendChild(styleElement);
		styleElement.sheet.insertRule('.hide-mod { display: none !important; }');
	}
	if (window.myVars.HideMod2) {
		const styleElement = document.createElement('style');
		document.head.appendChild(styleElement);
		styleElement.sheet.insertRule('.hide-mod2 { display: none !important; }');
	}
	// Eingeschränkte Sachbearbeiter dürfen keine Rechnungen einsehen.
	if (istEingeschraenkterSachbearbeiter()) {
		const rechnungButton = document.getElementById('rechnung-button');
		if (rechnungButton) {
			rechnungButton.style.display = 'none';
		}
	}
	// System Services starten...
	SystemDialogService.instance.onAbort(() => systemNachrichtService.zeigeKleineNachricht('Eingabe abgebrochen'));
	await basedataService.init();

	// Initiale Oberflächenbestückung vornehmen: Unternehmensname, Betriebstätteauswahl, Mitarbeiterliste, Filter...
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const abrechnungstag = unternehmen?.Abrechnungstag ?? 31;
	// Wenn wir an einem Datum nach den Abrechnungstag neolohn öffnen, springen wir in den nächsten Monat
	const jetztTZ = dayjs.tz(new Date(), 'Europe/Berlin');
	window.myVars.aktuellesMonatsDatum = jetztTZ.date() > abrechnungstag ? jetztTZ.startOf('month').add(1, 'month') : jetztTZ.startOf('month');
	document.querySelector('#monats-auswahl').value = window.myVars.aktuellesMonatsDatum.format('YYYY-MM');

	await fuelleBetriebSelect();
	const betriebID = document.getElementById('menu-betriebsstaette').value;
	stammdatenService.aktuelleBetriebsstaette = betriebID;
	let firma = unternehmen.UnternehmenName;
	let betriebName
	if (betriebID) {
		betriebName = unternehmen.Betriebsstaette.find((bs) => _.isEqual(bs._id, betriebID));
		firma = firma + '\n' + betriebName?.BetriebsstaetteName;
	}
	document.getElementById('title-betriebsstaette').innerText = firma;
	document.getElementById('sidebar-toggle-title').innerText = betriebName?.BetriebsstaetteName ? betriebName.BetriebsstaetteName : unternehmen.UnternehmenName;
	await erstelleMitarbeiterListe(betriebID);
	let pgs = await basedataService.holePGSBasedataProvider();
	// für die Messe filtern 101, 102, 106, 109, 110, alle anderen
	pgs = pgs.filter((pg) => ['101', '102', '106', '109', '110', '909'].includes(pg.Personengruppenschluessel));
	const pgsSelect = document.querySelector('#ma-filter-pgs');
	fuelleSelectOptionen(pgsSelect, pgs, 'Personengruppenschluessel', ['Personengruppenschluessel', 'PersonengruppeBezeichnung'], true, 'PGS, Beschäftigung (Alle)');

	const bereichSelect = document.querySelector('#ma-filter-bereich');
	const bereiche = unternehmen.Bereiche;
	// inaktive Bereiche ausblenden
	const bereicheAktiv = bereiche.filter((bereich) => bereich.Verwenden);
	fuelleSelectOptionen(bereichSelect, bereicheAktiv, '_id', 'Bereich', true, 'Bereiche');

	const einsatzortSelect = document.querySelector('#ma-filter-einsatzort');
	// Einsatzorte über alle Betriebsstätten hinweg, nur aktive
	const einsatzorteAktiv = unternehmen.Betriebsstaette.flatMap((bs) => bs.Einsatzorte.filter((eo) => eo.Verwenden));
	fuelleSelectOptionen(einsatzortSelect, einsatzorteAktiv, '_id', 'Bezeichnung', true, 'Einsatzorte');
	await lesePatchNotizen();

	// neochecker nur für Sachbearbeiter
	if (window.myVars.UserRoles.includes(Roles.Sachbearbeiter)) {
		const neoChecker = new NeoChecker();
		window.myServices.neoChecker = neoChecker;
		dashboard.render(document.getElementById('main'));
		// Beim ersten Aufruf zeigt die App das Dashboard – Home-Button als aktiv markieren.
		document.getElementById('home-button')?.classList.add('topmenu-active');
	} else {
		// Nutzer ohne Dashboard-Zugriff sehen beim ersten Aufruf das Firmenlogo als Homepage.
		zeigeFirmenlogoHome();
		document.getElementById('home-button')?.classList.add('topmenu-active');
	}
	initSidebarToggle();
	toggleLoader();
});

async function lesePatchNotizen() {
	const version = localStorage.getItem('patch-version');
	if (!version || version !== '2.0.4') {
		await fetchToHtml('patch_notes', 'patch-notes-body');
		const input = await SystemDialogService.instance.displayAsync('patch-notes-dialog');
		if (input.success) {
			localStorage.setItem('patch-version', '2.0.4');
		}
	}
}

function initSidebarToggle() {
	// Sidebar toggle functionality
	const sidebar = document.getElementById('sidebar');
	const sidebarToggle = document.getElementById('sidebar-toggle');
	const sidebarOverlay = document.getElementById('sidebar-overlay');

	function toggleSidebar() {
		sidebar.classList.toggle('open');
		sidebarOverlay.classList.toggle('open');
		sidebarToggle.setAttribute('aria-expanded', sidebar.classList.contains('open'));
	}

	sidebarToggle.addEventListener('click', toggleSidebar);

	// Close sidebar when overlay is clicked
	sidebarOverlay.addEventListener('click', () => {
		sidebar.classList.remove('open');
		sidebarOverlay.classList.remove('open');
		sidebarToggle.setAttribute('aria-expanded', 'false');
	});

	// Close sidebar when employee is selected
	document.addEventListener('click', (e) => {
		// Only close if clicking inside sidebar and it's a selectable item
		if (sidebar.classList.contains('open') && e.target.closest('#malist')) {
			sidebar.classList.remove('open');
			sidebarOverlay.classList.remove('open');
			sidebarToggle.setAttribute('aria-expanded', 'false');
		}
	});

	// Close on Escape key
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && sidebar.classList.contains('open')) {
			sidebar.classList.remove('open');
			sidebarOverlay.classList.remove('open');
			sidebarToggle.setAttribute('aria-expanded', 'false');
		}
	});
}

// führt die Website quasi in den Home Zustand zurück.
function resetHome() {
	stammdatenService.aktuellerMitarbeiter = {};
	letzteMitarbeiterID = null;
	// reset neochecker
	window.myServices?.neoChecker ? window.myServices?.neoChecker.loadEmployeeChecklist({}) : null;
	const betriebID = document.getElementById('menu-betriebsstaette').value;
	stammdatenService.aktuelleBetriebsstaette = betriebID;
	setMenuInactive('submenu-active');
	setMenuInactive('topmenu-active');
	// Home-Button als aktive Auswahl markieren – ein topmenuClick (oder ein anderer
	// resetHome) entfernt die Klasse über setMenuInactive('topmenu-active') wieder.
	const homeBtn = document.getElementById('home-button');
	if (homeBtn) homeBtn.classList.add('topmenu-active');
	setVisibility('.mamenu', 'none');
	setVisibility('.vwmenu', 'none');
	setVisibility('.reportmenu', 'none');
	hightlightMA();
	let firma = stammdatenService.unternehmen.UnternehmenName;
	if (betriebID) {
		const betriebName = stammdatenService.unternehmen.Betriebsstaette.find((bs) => _.isEqual(bs._id, betriebID));
		firma = firma + '\n' + betriebName?.BetriebsstaetteName;
	}
	document.getElementById('title-betriebsstaette').innerText = `${firma}`;
	document.getElementById('sidebar-toggle-title').innerText = `${firma}`;
	window.myVars.websiteStatus = 'home';
	document.getElementById('result').innerHTML = '';
	erstelleMitarbeiterListe(stammdatenService.aktuelleBetriebsstaette);
	// Dashboard nur für Sachbearbeiter als Homepage rendern.
	if (window.myVars.UserRoles.includes(Roles.Sachbearbeiter)) {
		dashboard.render(document.getElementById('main'));
	} else {
		zeigeFirmenlogoHome();
	}
}

// Merkt sich den aktuell ausgewählten Mitarbeiter, bevor die Auswahl zurückgesetzt wird.
function merkeLetztenMitarbeiter() {
	if (!_.isEmpty(stammdatenService.aktuellerMitarbeiter)) {
		letzteMitarbeiterID = stammdatenService.aktuellerMitarbeiter._id;
	}
}

// Öffnet die Rechnungen Oberfläche. Setzt die Mitarbeiterauswahl zurück und lädt die Seite.
async function openRechnungen() {
	// Eingeschränkte Sachbearbeiter dürfen keine Rechnungen einsehen.
	if (istEingeschraenkterSachbearbeiter()) {
		return;
	}
	// Mitarbeiterauswahl zurücksetzen, falls zuvor ein MA ausgewählt war.
	merkeLetztenMitarbeiter();
	stammdatenService.aktuellerMitarbeiter = {};
	window.myServices?.neoChecker?.loadEmployeeChecklist({});
	hightlightMA();
	// Menüs zurücksetzen wie bei einem Topmenü-Wechsel.
	setMenuInactive('submenu-active');
	setMenuInactive('topmenu-active');
	setVisibility('.mamenu', 'none');
	setVisibility('.vwmenu', 'none');
	setVisibility('.reportmenu', 'none');
	window.myVars.websiteStatus = 'vw-rechnung';
	document.getElementById('result').innerHTML = '';
	await fetchToHtml('vw_rechnung', 'main');
	await ladeRechnung();
	document.getElementById('rechnung-button')?.classList.add('topmenu-active');
}

// Zeigt für Nutzer ohne Dashboard-Zugriff das hinterlegte Firmenlogo auf der Homepage.
// Ist kein Logo hinterlegt (Bild lädt nicht), bleibt der Bereich leer.
function zeigeFirmenlogoHome() {
	const main = document.getElementById('main');
	main.innerHTML = `
		<div class="home-firmenlogo widget-company-logo">
			<img src="/neolohn/api/unternehmen/logo" alt="Firmenlogo" />
		</div>
	`;
	const img = main.querySelector('img');
	img.addEventListener('error', () => {
		main.innerHTML = '';
	});
}

// Wechselt die Betriebsstätte nach Auswahl im select-betriebsstaette oben links
async function wechsleBetrieb(thisElement) {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const bs = thisElement.options[thisElement.selectedIndex];
	const betriebChanged = bs.value !== stammdatenService.aktuelleBetriebsstaette;
	// Reset Mitarbeiterauswahl bei Betriebwechsel
	if (!_.isEmpty(stammdatenService.aktuellerMitarbeiter) && bs.value !== '' && betriebChanged) {
		stammdatenService.aktuellerMitarbeiter = {};
		// reset neochecker
		window.myServices?.neoChecker ? window.myServices?.neoChecker.loadEmployeeChecklist({}) : null;
		setMenuInactive('submenu-active');
		setMenuInactive('topmenu-active');
		window.myVars.websiteStatus = 'home';
		document.getElementById('home-button')?.classList.add('topmenu-active');
		document.getElementById('result').innerHTML = '';
	}
	stammdatenService.aktuelleBetriebsstaette = bs.value;
	let firma = bs.text;
	if (bs.value === '') {
		firma = unternehmen.UnternehmenName;
		stammdatenService.aktuelleBetriebsstaette = undefined;
	}
	// Dashboard neu rendern wenn der Betrieb gewechselt wurde und die Homepage offen ist.
	// (Neu rendern erst nach Aktualisierung von aktuelleBetriebsstaette, damit Widgets
	// die neue Betriebsstätte für ihre Anfragen verwenden.)
	if (betriebChanged && window.myVars.websiteStatus === 'home' && window.myVars.UserRoles.includes(Roles.Sachbearbeiter)) {
		dashboard.render(document.getElementById('main'));
	}
	if (window.myVars.websiteStatus === 'tagesuebersicht') {
		await ladeTagesuebersicht(new Date());
	}
	
	const MA = stammdatenService.aktuellerMitarbeiter;
	if (_.isEmpty(MA)) {
		document.getElementById('title-betriebsstaette').innerText = firma;
		document.getElementById('sidebar-toggle-title').innerText = firma;
	} else {
		document.getElementById('title-betriebsstaette').innerText = `${firma} | ${MA.Beschaeftigung[0].Personengruppenschluessel} - ${MA.Personalien.Personalnummer} ${MA.Personalien.Nachname}, ${MA.Personalien.Vorname}`;
		document.getElementById('sidebar-toggle-title').innerText = `${MA.Beschaeftigung[0].Personengruppenschluessel} - ${MA.Personalien.Personalnummer} ${MA.Personalien.Nachname}, ${MA.Personalien.Vorname}`;
	}
	
	// Early Return falls wir Bewerbungen einsehen...
	if (document.getElementById('menu-ma-aktiv').value == '2') return;
	await erstelleMitarbeiterListe(bs.value);
	updateAuswahlAnzahlMA();
}

// Monatwechsel durch den Monat Picker oben links in der Oberfläche
async function monatsWechselPick(thisElement) {
	// Bei Monatsdatum müssen wir es direkt mit der Timezone erstellen
	window.myVars.aktuellesMonatsDatum = dayjs.tz(thisElement.value, dayjs.tz.DEFAULT_TZ);
	document.querySelector('#monats-auswahl').value = window.myVars.aktuellesMonatsDatum.format('YYYY-MM');
	await monatsWechselAktion();
}

// Event getriggert durch klicken der Monatspfeile
async function monatsWechselEvent(wechselWert) {
	const element = document.querySelector('#monats-auswahl');
	window.myVars.aktuellesMonatsDatum = window.myVars.aktuellesMonatsDatum.add(wechselWert, 'month');
	element.value = window.myVars.aktuellesMonatsDatum.format('YYYY-MM');
	await monatsWechselAktion();
	updateAuswahlAnzahlMA();
}

// Monatswechselfunktion
async function monatsWechselAktion() {
	// Early Return falls wir Bewerbungen einsehen...
	if (document.getElementById('menu-ma-aktiv').value == '2') return;
	const bsDropDown = document.getElementById('menu-betriebsstaette').value;
	await erstelleMitarbeiterListe(bsDropDown);
	// Lade Mitarbeiter Daten neu
	if (window.myVars.websiteStatus.substring(0, 3) === 'ma-' && !_.isEmpty(stammdatenService.aktuellerMitarbeiter)) {
		await selectMA(stammdatenService.aktuellerMitarbeiter._id);
	}
	// Wenn wir im Topmenü Berichte sind, dann laden wir die Berichte für den Monat
	if (window.myVars.websiteStatus === 'berichte') {
		await ladeBerichteMA(false, true);
	}
	// Wenn wir in der Monatsübersicht sind, dann laden wir diese neu
	if (window.myVars.websiteStatus === 'monatsuebersicht') {
		await ladeMonatsuebersicht();
	}
	// Die Rechnungen-Ansicht verwaltet ihren Monat eigenständig (interner
	// Monatswechsel), daher wird sie hier bewusst nicht neu geladen.
}

// Wechselt den aktuell ausgewählten Mitarbeiter (mit Maus oder Pfeiltasten)
async function wechsleMitarbeiter(event) {
	event.preventDefault();
	const aktuellerMA = stammdatenService.aktuellerMitarbeiter;
	const malist = document.querySelector('#malist');
	const maArray = Array.from(malist.children);
	const maArrayVisible = maArray.filter((ma) => !ma.classList.contains('hidden'));
	let nextMA;
	if (maArrayVisible.length <= 0) {
		systemNachrichtService.zeigeKleineNachricht('Keine Mitarbeiter in der aktuellen Liste');
		return;
	}
	// Falls noch kein Mitarbeiter ausgewählt wurde, nehmen wir aufjedenfall den ersten (sichtbaren)
	if (Object.keys(aktuellerMA).length <= 0 && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
		nextMA = maArrayVisible[0];
		await selectMA(nextMA.id);
		return;
	}
	const index = maArrayVisible.findIndex((ma) => ma.id === aktuellerMA._id);
	// Gehe ein Feld in der Liste hoch
	if (event.key === 'ArrowUp') {
		nextMA = nextVisibleMitarbeiter(maArrayVisible, index, -1);
		await selectMA(nextMA.id);
	}
	// Gehe ein Feld in der Liste runter
	if (event.key === 'ArrowDown') {
		nextMA = nextVisibleMitarbeiter(maArrayVisible, index, 1);
		await selectMA(nextMA.id);
	}
	// Markiere aktuellen Mitarbeiter
	if (event.key === ' ' || event.key === 'Enter') {
		const ma = nextMA.querySelector('[aria-label="ma-control-check"]');
		ma.checked = !ma.checked;
	}
	// Markiere alle Mitarbeiter
	if (event.ctrlKey && event.key.toLowerCase() === 'a') {
		markMA(true);
	}
	nextMA?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
}

/**
 * Gibt den nächst sichbaren Mitarbeiter in der Mitarbeiter Liste zurück.
 * @param {array<HTMLElement>} maArray
 * @param {int} currentIndex aktueller Index des aktuellen Mitarbeiters in der Liste
 * @param {int} direction 1: nach unten / -1: nach oben
 * @returns nächster Mitarbeiter in der Mitarbeiterliste
 */
function nextVisibleMitarbeiter(maArray, currentIndex, direction) {
	let nextIndex = currentIndex + direction;
	// Am Ende der Liste müssen wir wieder von vorne anfangen
	if (currentIndex + direction < 0) {
		nextIndex = maArray.length - 1;
	}
	if (currentIndex + direction >= maArray.length) {
		nextIndex = 0;
	}
	return maArray[nextIndex];
}


/**
 * Controller für das Topmenü, updated das Grid für den Inhalt und die Submenüs
 * und ruft den Inhalt des ersten Submenü Inhalts auf.
 * @param {HTMLElement} element Topmenü Element
 * @param {*} event onclick
 */
function topmenuClick(element, event = null) {
	if (event !== null) event.stopPropagation();
	if ((element.id === 'Verwaltung') && window.myVars.HideMod) {
		return;
	}
	if ((element.id === 'Berichte') && window.myVars.HideMod2) {
		return;
	}
	setMenuActive(element, 'topmenu-active');
	showSubmenu(element);
	showContent(element);
	// Reset submenu selection falls vorhanden
	if (document.querySelector('.submenu-active') !== null) {
		document.querySelector('.submenu-active').classList.remove('submenu-active');
	}
}

/**
 * Liest den Vor- und Nachnamen aus nachdem der User OK klickt im Dialog.
 */
function confirmMaNeuDialog() {
	SystemDialogService.instance.confirm({	
		vorname: document.getElementById('ma-neu-vorname').value,
		nachname: document.getElementById('ma-neu-nachname').value,
		email: document.getElementById('ma-neu-email').value
	});
}

/**
 * Klick Listener, der einen Neuen Mitarbeiter anlegt mithilfe einer Dialog Box.
 * @param {event} event das Klickevent, wird benötigt um event.stopPropagation() aufzurufen.
 */
async function maNeuClick(event) {
	if (event !== null) event.stopPropagation();
	const result = await SystemDialogService.instance.displayAsync('ma-neu-dialog');
	if (!result.success) {
		// User aktion abgebrochen
		return;
	}
	const erfolgreichErstellt = await stammdatenService.erstelleMitarbeiter(result.data.vorname, result.data.nachname, result.data.email);
	if (!erfolgreichErstellt) {
		return;
	}
	// reset input fields...
	resetDialogInput('ma-neu-dialog');
	// neuen mitarbeiter validieren und auswählen...
	stammdatenService.aktuellerMitarbeiter.Errors = await window.myServices.maValidationService.validate(stammdatenService.aktuellerMitarbeiter);
	await erstelleMitarbeiterListe(stammdatenService.aktuelleBetriebsstaette);
	selectMA(stammdatenService.aktuellerMitarbeiter._id);
}

/**
 * Klick Listener, der einen Lohnabrechnugsbericht öffnet im Popup
 * @param {event} event das Klickevent, wird benötigt um event.stopPropagation() aufzurufen.
 */
async function maLohnabrechnungClick(event) {
	if (event !== null) event.stopPropagation();
	if (_.isEmpty(stammdatenService.aktuellerMitarbeiter)) {
		systemNachrichtService.zeigeKleineNachricht('Kein Mitarbeiter gewählt!', 0);
		return;
	}
	const zeitraum = getAktuellerZeitraum();
	const result = await stammdatenService.postBerichteMA([stammdatenService.aktuellerMitarbeiter._id], zeitraum, 'lohnabrechnung');
	if (result) {
		// Ein bereits offenes Lohnabrechnung Popup benutzen wir weiter, damit es seine Position behält.
		const lohnabrechnungPopUpOffen = window.myVars.popUpBericht && !window.myVars.popUpBericht.closed
			&& window.myVars.popUpBericht.document.title === 'Lohnabrechnung';
		if (!lohnabrechnungPopUpOffen) {
			// Porträit oder Querformat
			const landscape = 'width=750px, height=1080px,';
			if (window.myVars.popUpBericht) {
				window.myVars.popUpBericht.close();
			}
			window.myVars.popUpBericht = window.open('', 'popup', `${landscape} toolbar=no, menubar=no, resizable=yes`);
		}
        window.myVars.popUpBericht.document.open();
        window.myVars.popUpBericht.document.write(result[0]);
        window.myVars.popUpBericht.document.close();
        window.myVars.popUpBericht.document.title = 'Lohnabrechnung';
        window.myVars.popUpBericht.focus();
	}
}

function setVisibility(selector, displayType) {
	const myHiddenElements = document.querySelectorAll(selector);
	for (let i = 0; i < myHiddenElements.length; i += 1) {
		myHiddenElements[i].style.display = displayType;
	}
}

// Zeigt das Submenü an, falls es eins gibt für den Topmenü Reiter
function showSubmenu(element) {
	setVisibility('.submenu.reportmenu, .submenu.mamenu, .submenu.tagesuebersichtmenu, .submenu.monatsuebersichtmenu, .submenu.vwmenu', 'none');
	switch (element.id) {
		case 'Dienstplan':
			break;
		case 'Mitarbeiter':
			setVisibility('.mamenu', 'flex');
			break;
		case 'Berichte':
			setVisibility('.reportmenu', 'flex');
			break;
		case 'Tagesuebersicht':
			setVisibility('.tagesuebersichtmenu', 'flex');
			break;
		case 'Monatsuebersicht':
			setVisibility('.monatsuebersichtmenu', 'flex');
			break;
		case 'Verwaltung':
			setVisibility('.vwmenu', 'flex');
			break;
		default:
			break;
	}
}

/**
 * Führt die Aktion des Submenu aus bzw. ladet die entsprechende HTML Oberfläche und führt code aus.
 * @param {HTMLElement} element das HTMLElement auf das geklickt wurde.
 */
async function submenuClick(element) {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	// Check in welchen Submenu wir uns befinden
	if (element.classList.contains('mamenu')) {
		/* Mitarbeiter Submenu */
		const aktuellerMA = stammdatenService.aktuellerMitarbeiter;
		// Wir checken ob wir uns in einem abgeschlossenen Monat befinden (nur wenn es ein abgeschlossenes Journalobjekt gibt.)
		const journalMA = stammdatenService.aktuellesMitarbeiterJournal;
		const monatAbgeschlossen = !_.isEmpty(journalMA) && journalMA.Abgeschlossen === true;
		let unternehmenMonatsende = window.myVars.aktuellesMonatsDatum.endOf('month');
		// Bei abweichenden Abrechnungstag, abweichendes Monatsende verwenden
		if (stammdatenService.unternehmensobjekt.Abrechnungstag != 31) {
			unternehmenMonatsende = window.myVars.aktuellesMonatsDatum.startOf('month').add(stammdatenService.unternehmensobjekt.Abrechnungstag - 1, 'days');
		}
		// wir checken ob der Mitarbeiter im Zeitraum schon beschäftigt ist, falls nicht, sperren wir ihn
		const maEintritt = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Eintrittsdatum;
		const nichtBeschaeftigterZeitraum = unternehmenMonatsende.format('YYYY-MM-DD') < maEintritt;
		let mitarbeiterDisplay = aktuellerMA;
		// Bei Sachbearbeitern die Werte aus dem Journal anzeigen...
		if (monatAbgeschlossen && !window.myVars.HideMod) {
			mitarbeiterDisplay = journalMA.Mitarbeiter;
		}
		switch (element.id) {
			case 'Uebersicht':
				window.myVars.websiteStatus = 'ma-uebersicht';
				await fetchToHtml('ma_uebersicht', 'main');
				ladeUebersicht(mitarbeiterDisplay, unternehmen);
				break;
			case 'Personalien':
				if (window.myVars.HideMod2) {
					return;
				}
				window.myVars.websiteStatus = 'ma-personalien';
				await fetchToHtml('ma_personalien', 'main');
				await ladePersonalien(mitarbeiterDisplay);
				sperreOberflaeche(monatAbgeschlossen || nichtBeschaeftigterZeitraum);
				break;
			case 'Beschäftigung':
				if (window.myVars.HideMod2) {
					return;
				}
				window.myVars.websiteStatus = 'ma-beschaeftigung';
				await fetchToHtml('ma_beschaeftigung', 'main');
				await ladeBeschaeftigung(mitarbeiterDisplay, unternehmen);
				sperreOberflaeche(monatAbgeschlossen || nichtBeschaeftigterZeitraum);
				break;
			case 'Lohnarten':
				if (window.myVars.HideMod) {
					return;
				}
				window.myVars.websiteStatus = 'ma-lohnarten';
				await fetchToHtml('ma_lohnarten', 'main');
				ladeMALohnarten(mitarbeiterDisplay, unternehmen);
				sperreOberflaeche(monatAbgeschlossen || nichtBeschaeftigterZeitraum);
				break;
			case 'Zuschlaege':
				if (window.myVars.HideMod) {
					return;
				}
				window.myVars.websiteStatus = 'ma-zuschlaege';
				await fetchToHtml('ma_zuschlaege', 'main');
				ladeZuschlaege(mitarbeiterDisplay);
				sperreOberflaeche(monatAbgeschlossen || nichtBeschaeftigterZeitraum);
				break;
			case 'Abgaben':
				if (window.myVars.HideMod2) {
					return;
				}
				window.myVars.websiteStatus = 'ma-abgaben';
				await fetchToHtml('ma_abgaben', 'main');
				await ladeAbgaben(mitarbeiterDisplay);
				sperreOberflaeche(monatAbgeschlossen || nichtBeschaeftigterZeitraum);
				break;
			case 'Zeitkonto':
				window.myVars.websiteStatus = 'ma-zeitkonto';
				await fetchToHtml('ma_zeitkonto', 'main');
				await ladeZeitkonto(mitarbeiterDisplay);
				sperreOberflaeche(monatAbgeschlossen || nichtBeschaeftigterZeitraum);
				// Zeitenpfleger darf keine Urlaubsansprüche verändern
				document.querySelector('[aria-label="ma-UrlaubsanspruchZusatzProJahr"]').disabled = document.querySelector('[aria-label="ma-UrlaubsanspruchZusatzProJahr"]').disabled || window.myVars.HideMod2;
				break;
			case 'Zeiten':
				window.myVars.websiteStatus = 'ma-zeiten';
				await fetchToHtml('ma_zeiten', 'main');
				await zeitenScript();
				sperreOberflaeche(monatAbgeschlossen || nichtBeschaeftigterZeitraum);
				break;
			case 'Postfach':
				if (window.myVars.HideMod2) {
					return;
				}
				if (window.myVars.websiteStatus !== 'ma-postfach') {
					// reset document sort, wenn woanders gewesen
					window.myVars.sortDokumentType = 0;
					window.myVars.websiteStatus = 'ma-postfach';
				}
				await fetchToHtml('ma_postfach', 'main');
				// dynamic import statement
				const { default: EditorService } = await import('./services/editorService.js');
				window.myServices.editorService = new EditorService();
				// Wir können das Postfach nur öffnen falls ein MA ausgewählt wurde
				if (!_.isEmpty(stammdatenService.aktuellerMitarbeiter)) {
					await ladeMitarbeiterPostfach();
				} else {
					systemNachrichtService.zeigeKleineNachricht('Kein Mitarbeiter ausgewählt!', 0);
				}
				break;
			case 'Historie':
				if (window.myVars.HideMod) {
					return;
				}
				window.myVars.websiteStatus = 'ma-historie';
				await fetchToHtml('ma_historie', 'main');
				await ladeHistorie(mitarbeiterDisplay);
				break;
			default:
				break;
		}
	} else {
		/* Verwaltung Submenu */
		switch (element.id) {
			case 'Stammdaten':
				window.myVars.websiteStatus = 'vw-stammdaten';
				await fetchToHtml('vw_stammdaten', 'main');
				await ladeVerwaltung();
				break;
			case 'Lohnarten-vw':
				window.myVars.websiteStatus = 'vw-lohnarten';
				await fetchToHtml('vw_lohnarten', 'main');
				await ladeLohnarten();
				break;
			case 'Qualifikationen':
				window.myVars.websiteStatus = 'vw-qualifikationen';
				await fetchToHtml('vw_qualifikationen', 'main');
				await ladeQualifikationen(unternehmen);
				break;
			case 'Einsatzorte':
				window.myVars.websiteStatus = 'vw-einsatzorte';
				await fetchToHtml('vw_einsatzorte', 'main');
				await ladeEinsatzorte();
				break;
			case 'Schriftverkehr':
				if (window.myVars.HideMod) {
					return;
				}
				window.myVars.websiteStatus = 'vw-schriftverkehr';
				await fetchToHtml('vw_schriftverkehr', 'main');
				// dynamic import statement
				const { default: EditorService } = await import('./services/editorService.js');
				window.myServices.editorService = new EditorService();
				await ladeSchriftverkehr();
				break;
			case 'Benutzer':
				if (window.myVars.HideMod) {
					return;
				}
				window.myVars.websiteStatus = 'vw-benutzer';
				await fetchToHtml('vw_benutzer', 'main');
				await ladeBenutzerverwaltung();
				break;
			case 'Zeitregeln':
				window.myVars.websiteStatus = 'vw-zeitregeln';
				await fetchToHtml('vw_zeitregeln', 'main');
				await ladeZeitregeln(unternehmen);
				break;
			case 'Einstellungen':
				window.myVars.websiteStatus = 'vw-einstellungen';
				await fetchToHtml('vw_einstellungen', 'main');
				await ladeAlleEinstellungen();
				break;
			case 'Krankenkassen':
				window.myVars.websiteStatus = 'vw-krankenkassen';
				await fetchToHtml('vw_krankenkassen', 'main');
				await ladeKrankenkassen();
				break;
			case 'Betriebsregeln':
				window.myVars.websiteStatus = 'vw-betriebsregeln';
				await fetchToHtml('vw_betriebsregeln', 'main');
				ladeBetriebsregeln();
				break;
			default:
				break;
		}
		// Eingeschränkte Sachbearbeiter dürfen unternehmensweite Daten nur einsehen, nicht bearbeiten.
		sperreVerwaltungFuerEingeschraenkteSachbearbeiter();
	}
	setMenuActive(element, 'submenu-active');
}

/**
 * Sperrt nach dem Laden einer Verwaltungs-Ansicht alle Controls, die unternehmensweite (nicht der
 * eigenen Betriebsstätte zugehörige) Daten bearbeiten würden – passend zum serverseitigen Merge,
 * der solche Änderungen ohnehin verwirft. Betriebsstätten-bezogene Ansichten bleiben editierbar.
 */
function sperreVerwaltungFuerEingeschraenkteSachbearbeiter() {
	if (!istEingeschraenkterSachbearbeiter()) {
		return;
	}
	const status = window.myVars.websiteStatus;
	// Einsatzorte sind betriebsstättenbezogen, Benutzerverwaltung regelt ihre Sperren selbst.
	if (status === 'vw-einsatzorte' || status === 'vw-benutzer') {
		return;
	}
	if (status === 'vw-stammdaten') {
		// Nur das Unternehmens-Panel sperren; die (gefilterte) eigene Betriebsstätte bleibt editierbar.
		disableFormControls(document.getElementById('u-input-panel'));
		// Neue Betriebsstätten dürfen eingeschränkte Sachbearbeiter nicht anlegen.
		const createBtn = document.getElementById('bs-create-button');
		if (createBtn) {
			createBtn.style.display = 'none';
		}
		return;
	}
	if (status === 'vw-zeitregeln') {
		// Der Zeitenimport ist betriebsbezogen und bleibt für die eigene Betriebsstätte nutzbar
		// (der Server erzwingt ohnehin die eigene Betriebsstätte). Die Pausenmodelle dürfen
		// durchgeblättert, aber nicht bearbeitet werden – das regelt vw_zeitregeln.js beim
		// Rendern (die Pausenzeilen werden dynamisch neu erzeugt). Urlaubssperren und weitere
		// Einstellungen sind unternehmensweit und werden komplett gesperrt.
		disableFormControls(document.getElementById('u-Urlaubssperren'));
		disableFormControls(document.getElementById('u-Gutzeitregeln'));
		return;
	}
	// Alle übrigen Verwaltungs-Ansichten sind unternehmensweit -> komplett sperren.
	disableFormControls(document.getElementById('main'));
}
// Zeigt den Inhalt eines bestimmten Topmenüs an.
async function showContent(element) {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const betriebWahl = document.getElementById('menu-betriebsstaette')?.value;
	const betriebstaette = betriebWahl ? stammdatenService.unternehmensobjekt.Betriebsstaette.find((u) => _.isEqual(u._id, betriebWahl)) : '';
	const firma = betriebstaette?.BetriebsstaetteName ? betriebstaette.BetriebsstaetteName : unternehmen.UnternehmenName;
	switch (element.id) {
		case 'Dienstplan':
			break;
		case 'Mitarbeiter':
			// Wir müssen hier den website status ändern, damit wir nicht wieder in Berichte landen.
			window.myVars.websiteStatus = 'ma-';
			if (_.isEmpty(stammdatenService.aktuellerMitarbeiter)) {
				// Zuletzt gewählten MA wiederherstellen, sofern er noch sichtbar ist, sonst den ersten sichtbaren (nicht herausgefilterten) laden.
				const letzterMaInList = letzteMitarbeiterID && document.querySelector(`#malist > .ma-control[id="${letzteMitarbeiterID}"]:not(.hidden)`)?.id;
				const firstMaInList = letzterMaInList || document.querySelector('#malist > .ma-control:not(.hidden)')?.id;
				if (firstMaInList) {
					await selectMA(firstMaInList);
					return;
				}
				document.getElementById('main').innerHTML = '<h3>Keine Mitarbeiter zur Auswahl!<h3>';
				return;
			}
			await selectMA(stammdatenService.aktuellerMitarbeiter._id);
			break;
		case 'Berichte':
			window.myVars.websiteStatus = 'berichte';
			document.getElementById('result').innerHTML = '';
			await fetchToHtml('ma_berichte', 'main');
			document.getElementById('title-betriebsstaette').innerText = firma;
			document.getElementById('sidebar-toggle-title').innerText = firma;
			await ladeBerichteMA(true);
			break;
		case 'Tagesuebersicht':
			window.myVars.websiteStatus = 'tagesuebersicht';
			document.getElementById('result').innerHTML = '';
			await fetchToHtml('ma_tagesuebersicht', 'main');
			document.getElementById('title-betriebsstaette').innerText = firma;
			document.getElementById('sidebar-toggle-title').innerText = firma;
			await ladeTagesuebersicht();
			break;
		case 'Monatsuebersicht':
			window.myVars.websiteStatus = 'monatsuebersicht';
			document.getElementById('result').innerHTML = '';
			await fetchToHtml('ma_monatsuebersicht', 'main');
			document.getElementById('title-betriebsstaette').innerText = firma;
			document.getElementById('sidebar-toggle-title').innerText = firma;
			await ladeMonatsuebersicht();
			break;
		case 'Verwaltung':
			// Mitarbeiterauswahl zurücksetzen und Unternehmensprotokoll im neoChecker anzeigen
			merkeLetztenMitarbeiter();
			stammdatenService.aktuellerMitarbeiter = {};
			hightlightMA();
			window.myServices?.neoChecker?.loadUnternehmenProtokoll();
			window.myVars.websiteStatus = 'vw-stammdaten';
			document.getElementById('result').innerHTML = '';
			await fetchToHtml('vw_stammdaten', 'main');
			await ladeVerwaltung();
			// Eingeschränkte Sachbearbeiter dürfen unternehmensweite Daten nur einsehen, nicht bearbeiten.
			sperreVerwaltungFuerEingeschraenkteSachbearbeiter();
			document.getElementById('title-betriebsstaette').innerText = firma;
			document.getElementById('sidebar-toggle-title').innerText = firma;
			break;
		default:
			window.myVars.websiteStatus = '?';
			document.getElementById('main').innerHTML = `<p>Hier kommt der/die/das ${element.id} hereingeladen!</p>`;
			document.getElementById('title-betriebsstaette').innerText = firma;
			document.getElementById('sidebar-toggle-title').innerText = firma;
			document.getElementById('result').innerHTML = '';
			break;
	}
}

/**
 * MA List Item Click Handler, lädt bzw. bestückt die entsprechende Oberfläche nach Auswahl des Mitarbeiters
 * @param {string} mitarbeiterID
 */
async function selectMA(mitarbeiterID, targetSubmenu) {
	let aktuellerMA = stammdatenService.aktuellerMitarbeiter;
	// Wenn wir den Mitarbeiter wechseln, dann müssen wir ihn neu laden
	if (mitarbeiterID !== aktuellerMA._id) {
		// Falls es noch ungespeicherte Änderungen gibt beim alten Mitarbeiter.
		await forceUpdateMA();
	}
	// Wir holen immer neue Daten wenn wir zum MA wechseln
	aktuellerMA = await stammdatenService.holeMitarbeiter(mitarbeiterID);
	// checkliste laden
	if (window.myServices.neoChecker) {
		window.myServices.neoChecker.loadEmployeeChecklist(mitarbeiterID, `– ${aktuellerMA.Personalien.Nachname}, ${aktuellerMA.Personalien.Vorname}`);
		// automatischer ma_check für Fristen
		neocheckerMitarbeiterFristen(window.myServices.neoChecker, aktuellerMA);
	}
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const zeitraum = window.myVars.aktuellesMonatsDatum.format('YYYY-MM-DD');
	let unternehmenMonatsbeginn = window.myVars.aktuellesMonatsDatum;
	let unternehmenMonatsende = window.myVars.aktuellesMonatsDatum.endOf('month');
	// Bei abweichenden Abrechnungstag müssen Mitarbeiter, noch sichtbar sein die am Monatsende austreten
	if (stammdatenService.unternehmensobjekt.Abrechnungstag != 31) {
		unternehmenMonatsbeginn = unternehmenMonatsbeginn.subtract(1, 'month').add(stammdatenService.unternehmensobjekt.Abrechnungstag, 'days');
		unternehmenMonatsende = window.myVars.aktuellesMonatsDatum.startOf('month').add(stammdatenService.unternehmensobjekt.Abrechnungstag - 1, 'days');
	}
	// wir checken ob der Mitarbeiter im Zeitraum beschäftigt ist, falls nicht, müssen wir ihn verlassen...
	const maEintritt = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Eintrittsdatum;
	const maAustritt = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Austrittsdatum || '9999-12-31';
	const nichtBeschaeftigterZeitraum =
		unternehmenMonatsende.format('YYYY-MM-DD') < maEintritt ||
		unternehmenMonatsbeginn.format('YYYY-MM-DD') > maAustritt;
	if (nichtBeschaeftigterZeitraum && document.getElementById('menu-ma-aktiv').value == 0) {
		resetHome();
		systemNachrichtService.zeigeKleineNachricht('Beschäftigungszeitraum des Mitarbeiters verlassen!');
		return;
	}

	// Lade Journaldaten neu
	const journalMA = await stammdatenService.leseJournalMitarbeiter(stammdatenService.aktuellerMitarbeiter._id, zeitraum);
	hightlightMA();
	// Wir checken ob wir uns in einem abgeschlossenen Monat befinden (nur wenn es ein abgeschlossenes Journalobjekt gibt.)
	const monatAbgeschlossen = !_.isEmpty(journalMA) && journalMA.Abgeschlossen === true;
	let mitarbeiterDisplay = aktuellerMA;
	if (monatAbgeschlossen && !_.isEmpty(journalMA.Mitarbeiter)) {
		mitarbeiterDisplay = journalMA.Mitarbeiter;
	}

	// Optionaler Sprung direkt in ein bestimmtes Mitarbeiter-Submenu (z.B. von Dashboard-Widgets aus).
	// Vermeidet den Umweg über die Standard-Übersicht beim Anwählen eines Mitarbeiters.
	if (targetSubmenu) {
		const targetEl = document.getElementById(targetSubmenu);
		if (targetEl && targetEl.classList.contains('mamenu')) {
			setMenuActive(document.getElementById('Mitarbeiter'), 'topmenu-active');
			setVisibility('.vwmenu', 'none');
			setVisibility('.mamenu', 'flex');
			setVisibility('.reportmenu', 'none');
			setVisibility('.tagesuebersichtmenu', 'none');
			setVisibility('.monatsuebersichtmenu', 'none');
			await fetchToHtml('ma_result', 'result');
			setMenuActive(targetEl, 'submenu-active');
			await submenuClick(targetEl);
			if (!window.myVars.HideMod && window.myVars.websiteStatus.substring(0, 3) === 'ma-') {
				showResultMA(journalMA);
			}
			return;
		}
	}

	switch (window.myVars.websiteStatus) {
		case 'ma-uebersicht':
			ladeUebersicht(mitarbeiterDisplay, unternehmen);
			break;
		case 'ma-personalien':
			await ladePersonalien(mitarbeiterDisplay);
			sperreOberflaeche(monatAbgeschlossen);
			break;
		case 'ma-beschaeftigung':
			await ladeBeschaeftigung(mitarbeiterDisplay, unternehmen);
			sperreOberflaeche(monatAbgeschlossen);
			break;
		case 'ma-lohnarten':
			ladeMALohnarten(mitarbeiterDisplay, unternehmen);
			sperreOberflaeche(monatAbgeschlossen);
			break;
		case 'ma-zuschlaege':
			ladeZuschlaege(mitarbeiterDisplay);
			sperreOberflaeche(monatAbgeschlossen);
			break;
		case 'ma-abgaben':
			await ladeAbgaben(mitarbeiterDisplay);
			sperreOberflaeche(monatAbgeschlossen);
			break;
		case 'ma-zeitkonto':
			await ladeZeitkonto(mitarbeiterDisplay);
			sperreOberflaeche(monatAbgeschlossen);
			break;
		case 'ma-zeiten':
			await zeitenScript(false);
			sperreOberflaeche(monatAbgeschlossen);
			break;
		case 'ma-postfach':
			await ladeMitarbeiterPostfach();
			break;
		case 'ma-historie':
			await ladeHistorie(mitarbeiterDisplay);
			break;
		case 'berichte':
			await ladeBerichteMA();
			break;
		default:
			window.myVars.websiteStatus = 'ma-uebersicht';
			setMenuActive(document.getElementById('Mitarbeiter'), 'topmenu-active');
			setVisibility('.vwmenu', 'none');
			setVisibility('.mamenu', 'flex');
			setVisibility('.reportmenu', 'none');
			setVisibility('.tagesuebersichtmenu', 'none');
			setVisibility('.monatsuebersichtmenu', 'none');
			await fetchToHtml('ma_uebersicht', 'main');
			await fetchToHtml('ma_result', 'result');
			setMenuActive(document.getElementById('Uebersicht'), 'submenu-active');
			ladeUebersicht(aktuellerMA, unternehmen);
			break;
	}
	// mitarbeiter ergebnis laden im Falle von Navigation im Mitarbeiter Reiter
	if (!window.myVars.HideMod && window.myVars.websiteStatus.substring(0, 3) === 'ma-') {
		showResultMA(journalMA);
	}
}

function malistClick(element) {
	setMenuActive(element, 'ma-select-active');
}

// Ladet bestimmte HTML Oberflächen Dateien
async function fetchToHtml(fetchid, htmlid) {
	let response;
	let prefix = '';
	switch (fetchid.substring(0, 3)) {
		case 'ma_':
			prefix = 'mitarbeiter/';
			break;
		case 'vw_':
			prefix = 'verwaltung/';
			break;
		default:
			break;
	}
	try {
		response = await fetch(`/neolohn/html/${prefix}${fetchid}.html`);
		if (response.ok) {
			const fetchhtml = await response.text();
			document.getElementById(htmlid).innerHTML = fetchhtml;
		} else {
			throw new Error(`${fetchid} konnte nicht geladen werden: ${response.statusText}`);
		}
	} catch (error) {
		console.log(response.status);
		systemNachrichtService.zeigeKleineNachricht('Fehler beim Laden der Oberfläche!', -1);
		console.log(error);
	}
}

/**
 * Berechnet die aktuell ausgewählten Mitarbeiter
 */
async function berechnenMA() {
	// Falls es Änderungen im Mitarbeiter Objekt gibt, müssen wir erst speichern und den debounce entfernen...
	await forceUpdateMA();
	if (rejectAktionBeiArchivierteMA()) {
		return;
	}
	const listeHTML = document.querySelectorAll('.ma-control');
	const markedMA = Array.from(listeHTML).filter((maHTML) => maHTML.querySelector('[aria-label="ma-control-check"]').checked);
	const zeitraum = window.myVars.aktuellesMonatsDatum.format('YYYY-MM-DD');
	// wir berechnen alle angehakten Mitarbeiter, ansonsten den aktuell ausgewählten Mitarbeiter. Angehakte haben Vorrang in der Logik.
	const maList = [];
	const maAbgeschlossenList = [];
	if (markedMA.length >= 1) {
		markedMA.forEach((ma) => {
			// Wir sammeln abgeschlossene MAs, um den User zu benachrichtigen
			if (!ma.querySelector('.ma-abgeschlossen-icon').classList.contains('hidden')) {
				maAbgeschlossenList.push(ma.id);
			} else {
				maList.push(ma.id);
			}
		});		
	} else {
		if (_.isEmpty(stammdatenService.aktuellerMitarbeiter)) {
			systemNachrichtService.zeigeKleineNachricht('Kein Mitarbeiter ausgewählt!', 0);
			return;
		}
		if (!_.isEmpty(stammdatenService.aktuellesMitarbeiterJournal) && stammdatenService.aktuellesMitarbeiterJournal.Abgeschlossen) {
			systemNachrichtService.zeigeKleineNachricht('Mitarbeiter ist bereits abgeschlossen!', -1);
			return;
		}
		maList.push(stammdatenService.aktuellerMitarbeiter._id);
	}
	// Bevor wir die Berechnung ausführen checken wir ob alle Vormonate abgeschlossen sind.
	const bereitsAbgeschlossen = !_.isEmpty(maAbgeschlossenList);
	if (bereitsAbgeschlossen) {
		const input = await SystemDialogService.instance.displayAsync('ma-abgeschlossen-warnung-dialog');
		if (!input.success) {
			systemNachrichtService.zeigeKleineNachricht('Berechnung wurde abgebrochen!', 0);
			return;
		}
	}
	// Bevor wir die Berechnung ausführen checken wir ob alle Vormonate abgeschlossen sind.
	const vormateAbgeschlossen = await stammdatenService.checkVormonatMitarbeiterListe(maList, zeitraum);
	if (!_.isEmpty(vormateAbgeschlossen)) {
		const input = await SystemDialogService.instance.displayAsync('ma-vormonate-warnung-dialog');
		if (!input.success) {
			systemNachrichtService.zeigeKleineNachricht('Berechnung wurde abgebrochen!', 0);
			return;
		}
	}
	let fehlerListe = [];
	// Der stammdatenService liefert false, wenn der Request selbst fehlschlägt (z.B. neolohn core nicht erreichbar).
	let berechnungAbgebrochen = false;
	// Wenn wir mehr als 20 Berechnungen durchführen müssen, teilen wir auf
	if (maList.length > 20) {
		const progressTitle = 'Berechnen von Mitarbeitern';
        const progressInfo = 'Die Berechnung dauert einen Moment.';
		const maListChunks = _.chunk(maList, 20);
		let progressCounter = 0;
		updateProgressbar(progressCounter, maList.length, progressTitle, progressInfo);
		for (const list of maListChunks) {
			const stopProgress = startChunkProgress(progressCounter, list.length, maList.length, progressTitle, progressInfo, 700);
			const chunkResult = await stammdatenService.berechneMitarbeiterListe(list, zeitraum);
			progressCounter += list.length;
			stopProgress(progressCounter);
			if (chunkResult === false) {
				berechnungAbgebrochen = true;
				break;
			}
			fehlerListe = _.union(fehlerListe, chunkResult);
		}
	} else {
		const result = await stammdatenService.berechneMitarbeiterListe(maList, zeitraum);
		if (result === false) {
			berechnungAbgebrochen = true;
		} else {
			fehlerListe = result;
		}
	}

	// Die Fehlermeldung kommt bereits aus dem stammdatenService, wir dürfen hier keinen Erfolg melden.
	if (berechnungAbgebrochen) {
		await erstelleMitarbeiterListe();
		return;
	}

	if (!_.isEmpty(fehlerListe)) {
		systemNachrichtService.zeigeKleineNachricht(`${maList.length === 1 ? 'Mitarbeiter konnte nicht berechnet werden!' : 'Nicht alle Mitarbeiter konnten berechnet werden!'}`, -1);
		if (fehlerListe.length < maList.length) {
			systemNachrichtService.zeigeKleineNachricht('Berechnung teilweise erfolgreich!', 0);
		} 
		systemNachrichtService.zeigeKleineNachricht('Bitte überprüfen Sie die Mitarbeiterdaten!', 0);
	} else {
		systemNachrichtService.zeigeKleineNachricht('Berechnung erfolgreich!', 1);
	}

	// Lade das Ergebnis für den aktuellen Mitarbeiter (darf nicht in der Fehlerliste vorkommen)
	if (fehlerListe.findIndex((id) => id === stammdatenService.aktuellerMitarbeiter._id) < 0 && !_.isEmpty(stammdatenService.aktuellerMitarbeiter)) {
		// aktualisiere den aktuellen Mitarbeiter
		await stammdatenService.holeMitarbeiter(stammdatenService.aktuellerMitarbeiter._id);
		// Wir holen und zeigen im Anschluss noch das Ergebnis des aktuellen Mitarbeiters (falls einer ausgewählt ist).
		// Lade Journaldaten neu
		const zeitraum = window.myVars.aktuellesMonatsDatum.format('YYYY-MM-DD');
		const journalMA = await stammdatenService.leseJournalMitarbeiter(stammdatenService.aktuellerMitarbeiter._id, zeitraum);
		showResultMA(journalMA);
		// falls wir uns in der ma-historie oder ma-zuschlaege befinden, laden wir diese neu.
		if (window.myVars.websiteStatus === 'ma-historie') {
			ladeHistorie(stammdatenService.aktuellerMitarbeiter);
		}
		if (window.myVars.websiteStatus === 'ma-zuschlaege') {
			ladeZuschlaege(stammdatenService.aktuellerMitarbeiter);
		}
		// Hinweis Überschreitung ggf Grenze
		const miloZeitraum = MindestlohnHistorie.find((milo) => {
				// falls der Zeitraum gleich oder nach dem GueltigAb Datum ist, dann wende den Mindestlohn an.
				if (zeitraum >= milo.GueltigAb) {
					return milo.MindestlohnStunde;
				}
			});
		if (!_.isEmpty(journalMA) && journalMA.Mitarbeiter.Beschaeftigung[0].Personengruppenschluessel == '109' && journalMA.Mitarbeiter.Ergebnis.SvBruttoAN > miloZeitraum.GeringfuegigGrenze) {
			document.querySelectorAll('.gfg-grenze-dialog').forEach((item) => item.innerText = miloZeitraum.GeringfuegigGrenze);
			await SystemDialogService.instance.displayAsync('sv-grenze-ma-alert-dialog');
		}
	}
	// aktualisieren der Mitarbeiter Liste, falls invalide Daten aufgetreten sind.
	await erstelleMitarbeiterListe();
	// Bei genau einem Mitarbeiter laden wir die geöffnete Lohnabrechnung in den Berichten neu.
	if (window.myVars.websiteStatus === 'berichte' && maList.length === 1
		&& document.querySelector('.report-item-active')?.id === 'lohnabrechnung-html') {
		await getZettelHTML('lohnabrechnung-html');
	}
	// Ebenso die Lohnabrechnung, falls sie in einem Popup geöffnet ist.
	if (maList.length === 1 && !_.isEmpty(stammdatenService.aktuellerMitarbeiter)
		&& window.myVars.popUpBericht && !window.myVars.popUpBericht.closed
		&& window.myVars.popUpBericht.document.title === 'Lohnabrechnung') {
		await maLohnabrechnungClick(null);
	}
}

/**
 * Zeigt das Ergebnis einer Berechnung unten im Mitarbeiter Spoiler an.
 * @param {string} journalMA mitarbeiter journal objekt
 */
async function showResultMA(journalMA) {
	// Falls wir uns nicht in einem Mitarbeiter befinden, müssen wir das Ergebnis nicht anzeigen
	if (_.isEmpty(stammdatenService.aktuellerMitarbeiter) || window.myVars.websiteStatus.substring(0, 3) !== 'ma-') {
		document.getElementById('result').style.display = 'none';
		return;
	}
	document.getElementById('result').style.display = 'grid';


	// Zuerst resetten wir die Values
	hideFreieMitarbeiterDetails(stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Personengruppenschluessel);
	document.querySelector('.details-umsatz-an').style.display = 'none';
	document.querySelector('.details-ez').style.display = 'none';
	const values = document.getElementById('result').querySelectorAll('.output_value');
	values.forEach((value) => {
		if (value.classList.contains('output_euro')) {
			value.innerText = convertNumberToEuro(0);
		} else {
			value.innerText = 0;
		}
	});
	// Reset Values
	document.getElementById('result-ag-monat').innerText = convertNumberToEuro(0);
	document.getElementById('result-ag-std').innerText = convertNumberToEuro(0);
	document.getElementById('result-ag-Umlagesatz3').innerText = convertNumberDE(journalMA.Zeitraum < '2025-01-01' ? 0.06 : 0.15);
	document.getElementById('result-an-brutto').innerText = convertNumberToEuro(0);
	document.getElementById('result-an-netto').innerText = convertNumberToEuro(0);
	document.getElementById('result-an-auszahlung').innerText = convertNumberToEuro(0);
	document.getElementById('result-an-std').innerText = '0,00';
	document.getElementById('result-bez-std').innerText = '0,00';
	document.getElementById('result-ag-ersparnis').innerText = '0,00 €';
	document.getElementById('result-ag-ersparnis').parentElement.style.display = 'none';
	updateResultSectionRadius();
	applyZeroMuting();
	// Falls das Objekt leer ist, können wir ein early return machen
	if (_.isEmpty(journalMA.Mitarbeiter)) {
		return;
	}
	// Falls wir uns im Mitarbeiter Reiter befinden, wollen wir das Ergebnis anzeigen lassen.
	if (window.myVars.websiteStatus.substring(0, 3) === 'ma-') {
		const htmlParent = document.getElementById('result');
		displayValues(journalMA.Mitarbeiter.Monatswerte, '', htmlParent, 'result-ag-');
		displayValues(journalMA.Mitarbeiter.Monatswerte, '', htmlParent, 'result-an-');
		const maErgebnisNormal = _.omit(journalMA.Mitarbeiter.Ergebnis, ['UmsatzorientiertAbrechnungsdetails', 'SonstigeBezuege']);
		displayValues(maErgebnisNormal, '', htmlParent, 'result-ag-');
		displayValues(maErgebnisNormal, '', htmlParent, 'result-an-');
		displayValues(journalMA.Mitarbeiter.Ergebnis.Zuschlaege, '', htmlParent, 'result-an-');
		const krankenkassensatz = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2}).format(journalMA.Mitarbeiter.Beschaeftigung[0].Krankenkasse.Satz);
		const krankenkassenzusatzsatz = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2}).format(journalMA.Mitarbeiter.Beschaeftigung[0].Krankenkasse.ZusatzSatz);
		htmlParent.querySelector('[aria-label="result-ag-KvAgProzent"]').innerText = `${krankenkassensatz}% ${krankenkassenzusatzsatz !== '0' ? `(+${krankenkassenzusatzsatz}%)`: ''}`;
		htmlParent.querySelector('[aria-label="result-an-KvAnProzent"]').innerText = `${krankenkassensatz}% ${krankenkassenzusatzsatz !== '0' ? `(+${krankenkassenzusatzsatz}%)`: ''}`;
		htmlParent.querySelector('#result-ag-monat').innerText = convertNumberToEuro(journalMA.Mitarbeiter.Ergebnis.AgGesamtkosten);
		htmlParent.querySelector('#result-ag-std').innerText = convertNumberToEuro(journalMA.Mitarbeiter.Ergebnis.AgGesamtkostenStunde);
		htmlParent.querySelector('#result-an-brutto').innerText = convertNumberToEuro(journalMA.Mitarbeiter.Ergebnis.Gesamtbrutto);
		htmlParent.querySelector('#result-an-netto').innerText = convertNumberToEuro(journalMA.Mitarbeiter.Ergebnis.NettolohnMonat);
		htmlParent.querySelector('#result-an-auszahlung').innerText = convertNumberToEuro(journalMA.Mitarbeiter.Ergebnis.Auszahlung);
		document.getElementById('result-an-std').innerText = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(journalMA.Mitarbeiter.Monatswerte.Arbeitsstunden);
		document.getElementById('result-bez-std').innerText = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(journalMA.Mitarbeiter.Monatswerte.BezahlteStunden ?? 0);
		if (!_.isEmpty(journalMA.Mitarbeiter.Ersparnis) && journalMA.Mitarbeiter.Ersparnis.AGKostenErsparnis > 0) {
			document.getElementById('result-ag-ersparnis').innerText = convertNumberToEuro(journalMA.Mitarbeiter.Ersparnis?.AGKostenErsparnis);
			document.getElementById('result-ag-ersparnis').parentElement.style.display = 'flex';
		}
		htmlParent.querySelector('[aria-label="result-ag-EGFZBruttoStunde"]').innerText = convertNumberToEuro(journalMA.Mitarbeiter.Monatswerte.EGFZBruttoStunde);

		showUmsatzDetails(journalMA, htmlParent, krankenkassensatz, krankenkassenzusatzsatz);
		showEinmalzahlungDetails(journalMA, htmlParent, krankenkassensatz, krankenkassenzusatzsatz);
		updateResultSectionRadius();
		applyZeroMuting();
	}
}

/**
 * Dämpft Null-Werte (0,00 €) in den Detailspalten Steuern, Sozialversicherung,
 * Umlagen und Zuschläge optisch ab. Wird per Skript gemacht, da die Werte dynamisch
 * berechnet werden. Gesamt-/Hero-Zeilen bleiben unverändert.
 */
function applyZeroMuting() {
	const muteCols = ['Steuern', 'Sozialversicherung', 'Sozialvers.', 'Umlagen', 'Zuschläge (SFN)'];
	document.getElementById('result').querySelectorAll('.ov-col').forEach((col) => {
		const titleEl = col.querySelector('.ov-col-h > span');
		const mute = titleEl && muteCols.includes(titleEl.textContent.trim());
		col.querySelectorAll('.ov-row').forEach((row) => {
			if (!mute || row.classList.contains('is-total') || row.classList.contains('is-hero')) {
				row.classList.remove('ov-zero');
				return;
			}
			const euro = row.querySelector('.output_euro');
			const digits = euro ? euro.textContent.replace(/\D/g, '') : '';
			row.classList.toggle('ov-zero', digits.length > 0 && /^0+$/.test(digits));
		});
	});
}

/**
 * Setzt die Rundungen der Ergebnis-Sektionen: nur die erste und letzte aktuell
 * sichtbare Sektion wird oben bzw. unten abgerundet. Wird per JS gemacht, da
 * Umsatz-/Einmalzahlung-Sektionen je nach Mitarbeiter dynamisch ein-/ausgeblendet werden.
 */
function updateResultSectionRadius() {
	const sections = document.getElementById('result').querySelectorAll('.ov-sec');
	sections.forEach((sec) => sec.classList.remove('first-visible', 'last-visible'));
	const visible = [...sections].filter((sec) => getComputedStyle(sec).display !== 'none');
	if (visible.length === 0) {
		return;
	}
	visible[0].classList.add('first-visible');
	visible[visible.length - 1].classList.add('last-visible');
}

function showUmsatzDetails(journalMA, resultHTML, krankenkassensatz, krankenkassenzusatzsatz) {
	const umsatzdetailsHTML = resultHTML.querySelector('.details-umsatz-an');
	const umsatzdetails = journalMA.Mitarbeiter.Ergebnis.UmsatzorientiertAbrechnungsdetails;
	if (_.isEmpty(umsatzdetails)) {
		umsatzdetailsHTML.style.display = 'none';
		return;
	}
	umsatzdetailsHTML.style.display = 'block';
	document.getElementById('umsatz-an-umsatz-brutto').innerText = convertNumberToEuro(umsatzdetails.UmsatzMonat);
	document.getElementById('umsatz-an-umsatzanteil-brutto').innerText = convertNumberToEuro(umsatzdetails.UmsatzBeteiligungMonat);
	document.getElementById('umsatz-an-umsatzanteil-prozent').innerText = formatNumber2Decimals(umsatzdetails.UmsatzBeteiligungMonat / umsatzdetails.UmsatzMonat * 100);
	document.getElementById('umsatz-an-UmsatzbeteiligungProzent').innerText = formatNumber2Decimals(umsatzdetails.UmsatzBeteiligungMonat / umsatzdetails.UmsatzMonat * 100);
	document.getElementById('umsatz-an-umsatz-anteil-netto').innerText = convertNumberToEuro(umsatzdetails.NettolohnMonat);
	displayValues(umsatzdetails, '', umsatzdetailsHTML, 'umsatz-an-');
	umsatzdetailsHTML.querySelector('[aria-label="umsatz-an-KvAnProzent"]').innerText = `${krankenkassensatz}% ${krankenkassenzusatzsatz !== '0' ? `(+${krankenkassenzusatzsatz}%)`: ''}`;
}

function showEinmalzahlungDetails(journalMA, resultHTML, krankenkassensatz, krankenkassenzusatzsatz) {
	const einmalzahlungHTML = resultHTML.querySelector('.details-ez');
	const einmalzahlung = journalMA.Mitarbeiter.EinmalzahlungDetails;
	if (_.isEmpty(einmalzahlung)) {
		einmalzahlungHTML.style.display = 'none';
		return;
	}
	einmalzahlungHTML.style.display = 'block';
	document.getElementById('result-ez-brutto').innerText = convertNumberToEuro(einmalzahlung.EinmalzahlungMonat);
	document.getElementById('result-ez-netto').innerText = convertNumberToEuro(einmalzahlung.NettolohnMonat);
	document.getElementById('result-ez-kosten').innerText = convertNumberToEuro(einmalzahlung.AgGesamtkosten);
	displayValues(einmalzahlung, '', einmalzahlungHTML, 'result-an-ez-');
	displayValues(einmalzahlung, '', einmalzahlungHTML, 'result-ag-ez-');
	einmalzahlungHTML.querySelector('[aria-label="result-an-ez-KvAnProzent"]').innerText = `${krankenkassensatz}% ${krankenkassenzusatzsatz !== '0' ? `(+${krankenkassenzusatzsatz}%)`: ''}`;
	einmalzahlungHTML.querySelector('[aria-label="result-ag-ez-KvAgProzent"]').innerText = `${krankenkassensatz}% ${krankenkassenzusatzsatz !== '0' ? `(+${krankenkassenzusatzsatz}%)`: ''}`;
}

function hideFreieMitarbeiterDetails(pgs) {
	const anResults = document.querySelector('.details-an');
	if (pgs == '909') {
		anResults.style.display = 'none';
	} else {
		anResults.style.display = 'block';
	}
}

/**
 * Exportiert die aktuell ausgewählten Mitarbeiter
 */
async function exportMA() {
	await forceUpdateMA();
	if (rejectAktionBeiArchivierteMA()) {
		return;
	}
	const zeitraum = window.myVars.aktuellesMonatsDatum.format('YYYY-MM-DD');
	// sammle alle angehakten MitarbeiterIDs
	const maList = getSelectedMitarbeiterIDs();
	if (maList.length < 1) {
		await SystemDialogService.displayAsync('kein-ma-alert-dialog');
		return;
	}
	const result = await stammdatenService.exportiereMitarbeiterListe(maList, zeitraum);
	// aktualisieren der Mitarbeiter Liste für die Abgeschlossen Symbole
	await erstelleMitarbeiterListe();
	// Falls wir einen Mitarbeiter ausgewählt hatten, laden wir dessen Stammdaten neu...
	if (!_.isEmpty(stammdatenService.aktuellerMitarbeiter)) {
		await stammdatenService.holeMitarbeiter(stammdatenService.aktuellerMitarbeiter._id);
	}
	// Falls der aktuelle Mitarbeiter abgeschlossen wurde, müssen wir die Oberfläche sperren.
	if (result 
		&& window.myVars.websiteStatus.substring(0, 3) === 'ma-'
		&& !_.isEmpty(stammdatenService.aktuellerMitarbeiter._id)) {
			selectMA(stammdatenService.aktuellerMitarbeiter._id);
		}
}

/**
 * Zeigt eine Liste der Fehler von der Mitarbeiter Validation in einer Dialog Box.
 * @param {string} mitarbeiterID
 */
async function showErrorsMA(mitarbeiterID) {
	const mitarbeiter = await stammdatenService.holeMitarbeiter(mitarbeiterID);
	const body = document.getElementById('errors-ma-alert-body');
	const boldText = document.createElement('h4');
	boldText.innerText = `Mitarbeiter: ${mitarbeiter.Personalien.Personalnummer} ${mitarbeiter.Personalien.Nachname}, ${mitarbeiter.Personalien.Vorname}`;
	body.appendChild(boldText);
	mitarbeiter.Errors.forEach((error) => {
		if (error.keyword === 'if') return; // skip if errors
		const newRow = document.createElement('p');
		const errorString = replaceAbgabenErrorString(error.instancePath);
		newRow.innerText = `${errorString.substring(1).replaceAll('/0/', '/').replaceAll('/', '>')}: ${error.message}`;
		body.appendChild(newRow);
	});
	await SystemDialogService.instance.displayAsync('errors-ma-alert-dialog');
	body.innerText = '';
}

/**
 * Zeigt eine Liste der Fehler von der Mitarbeiter Validation in einer Dialog Box.
 * @param {string} mitarbeiterID
 * @param {object} abweichungdetails
 */
async function showAbweichungMA(mitarbeiterID, abweichungdetails) {
	const mitarbeiter = await stammdatenService.holeMitarbeiter(mitarbeiterID);
	const body = document.getElementById('abweichung-ma-alert-body');
	const boldText = document.createElement('h4');
	boldText.innerText = `Mitarbeiter: ${mitarbeiter.Personalien.Personalnummer} ${mitarbeiter.Personalien.Nachname}, ${mitarbeiter.Personalien.Vorname}`;
	body.appendChild(boldText);
	const legende = document.createElement('p');
	const text = document.createElement('i');
	text.innerText = 'Wert: Abweichung (Gesamtbetrag aus der Lohnabrechnung)';
	legende.appendChild(text);
	body.appendChild(legende);
	const brutto = document.createElement('p');
	brutto.innerHTML = `<span>Gesamtbrutto: <b>${abweichungdetails.GesamtbruttoAbweichung > 0 ? '+' : ''}${convertNumberToEuro(abweichungdetails.GesamtbruttoAbweichung)}</b> (${convertNumberToEuro(abweichungdetails.Gesamtbrutto)})</span>`;
	body.appendChild(brutto);
	const netto = document.createElement('p');
	netto.innerHTML = `<span>Netto: <b>${abweichungdetails.NettoAbweichung > 0 ? '+' : ''}${convertNumberToEuro(abweichungdetails.NettoAbweichung)}</b> (${convertNumberToEuro(abweichungdetails.Netto)})</span>`;
	body.appendChild(netto);
	const auszahlung = document.createElement('p');
	auszahlung.innerHTML = `<span>Auszahlungsbetrag: <b>${abweichungdetails.AuszahlungsbetragAbweichung > 0 ? '+' : ''}${convertNumberToEuro(abweichungdetails.AuszahlungsbetragAbweichung)}</b> (${convertNumberToEuro(abweichungdetails.Auszahlungsbetrag)})</span>`;
	body.appendChild(auszahlung);
	await SystemDialogService.instance.displayAsync('abweichung-ma-alert-dialog');
	body.innerText = '';
}

/**
 * Zeigt eine Liste der Fehler von der Unternehmens Validation in einer Dialog Box.
 * @param {Event} event
 */
async function showErrorsUnternehmen(event) {
	event.stopPropagation();
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const body = document.getElementById('errors-u-alert-body');
	const boldText = document.createElement('b');
	boldText.innerText = `Unternehmen: ${unternehmen.UnternehmenName}`;
	body.appendChild(boldText);
	unternehmen.Errors.forEach((error) => {
		const newRow = document.createElement('p');
		const errorString = replaceAbgabenErrorString(error.instancePath);
		newRow.innerText = `${errorString.substring(1).replaceAll('/', '>')}: ${error.message}`;
		body.appendChild(newRow);
	});
	await SystemDialogService.instance.displayAsync('errors-u-alert-dialog');
	body.innerText = '';
}

function replaceAbgabenErrorString(errorString) {
	const abgaben = ['0/Steuer', '0/Krankenkasse', '0/FreiwilligeGesetzlicheKrankenversicherung', '0/FreiwilligeGesetzlichePflegeversicherung', '0/PrivateKrankenkasse', '0/Berufsgenossenschaft', '0/Sozialversicherung'];
	const abgabenReplace = ['Abgaben/Steuer', 'Abgaben/Krankenkasse', 'Abgaben/FreiwilligeGesetzlicheKrankenversicherung', 'Abgaben/FreiwilligeGesetzlichePflegeversicherung', 'Abgaben/PrivateKrankenkasse', 'Abgaben/Unfallversicherung', 'Abgaben/Sozialversicherung'];
	const containsAbgabeIndex = abgaben.findIndex((abg) => errorString.includes(abg));
	if (containsAbgabeIndex >= 0) {
		return errorString.replace(abgaben[containsAbgabeIndex], abgabenReplace[containsAbgabeIndex]);
	}
	return errorString;
}

/**
 * Markiert bzw. setzt das Häckchen in der Mitarbeiterliste bei allen angezeigten Mitarbeitern.
 * @param {boolean} mark true falls Häckchen gesetzt, sonst false.
 */
function markMA(mark) {
	const listeHTML = document.querySelectorAll('.ma-control:not(.hidden)');
	listeHTML.forEach((maHTML) => {
		maHTML.querySelector('[aria-label="ma-control-check"]').checked = mark;
	});
	updateAuswahlAnzahlMA();
}


// Öffnet und schließt das Panel
function toggleAccordion(thisElement) {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    thisElement.classList.toggle('active');
    /* Toggle between hiding and showing the active panel */
    const panel = thisElement.nextElementSibling;
    panel.classList.toggle('hidden');
}

// Click handler für das Schloss Symbol
async function monatEntsperrenMA(mitarbeiterID, event) {
	// Verhindert, dass der EventHandler des parent Elements den mitarbeiter durch selectMA sofort lädt.
	if (event) {
		event.stopPropagation();
	}
	// Dialog anzeigen
	const userDecision = await SystemDialogService.instance.displayAsync('ma-monat-entsperren-dialog');
	if (!userDecision.success) {
		return;
	}
	// zeitraum laden und Anfrage senden.
	const zeitraum = window.myVars.aktuellesMonatsDatum.format('YYYY-MM-DD');
	let result;
	if (userDecision.data.AlleMA) {
		result = await stammdatenService.entsperreJournaleAlleMA(zeitraum, stammdatenService.aktuelleBetriebsstaette);
	} else {
		result = await stammdatenService.entsperreJournalMA(mitarbeiterID, zeitraum);
	}
	// Mitarbeiter Daten und Liste neuladen
	if (result) {
		await stammdatenService.holeMitarbeiter(stammdatenService.aktuellerMitarbeiter._id);
		await selectMA(mitarbeiterID);
		await erstelleMitarbeiterListe();
		if (userDecision.data.AlleMA) {
			zeigeStammdatenAenderungen(result, true);
		} else {
			zeigeStammdatenAenderungen([{ Aenderungen: result }], false);
		}
	}
}

/**
 * Zeigt die Stammdaten-Änderungen seit dem Monatsabschluss (Journal vs. aktuelle Stammdaten) im verschiebbaren Fenster an.
 * @param {array<{Name: string, Aenderungen: array}>} aenderungenListe
 * @param {boolean} mitName Spalte mit dem Mitarbeiternamen anzeigen (beim Entsperren aller Mitarbeiter)
 */
function zeigeStammdatenAenderungen(aenderungenListe, mitName) {
	const unternehmen = stammdatenService.unternehmensobjekt;
	const formatiereWert = (path, value) => fmtValue(resolveValue(path, value, unternehmen, basedataService.beschaeftigungsarten)).text;
	const rows = [];
	aenderungenListe.forEach((eintrag) => {
		(eintrag.Aenderungen || []).forEach((aenderung) => {
			const feld = buildCrumbs(aenderung.path, unternehmen).map((c) => c.label + (c.index ? ` ${c.index}` : '')).join(' › ');
			const zeile = [feld, formatiereWert(aenderung.path, aenderung.oldValue), formatiereWert(aenderung.path, aenderung.value)];
			rows.push(mitName ? [eintrag.Name, ...zeile] : zeile);
		});
	});
	if (rows.length <= 0) {
		return;
	}
	const headers = ['Feld', 'Journal', 'Aktuell'];
	zeigeFehlerFenster(`Stammdaten-Änderungen seit Abschluss (${rows.length})`, {
		beschreibung: 'Folgende Stammdaten wurden seit dem Monatsabschluss geändert:',
		tabelle: { headers: mitName ? ['Mitarbeiter', ...headers] : headers, rows },
	});
}

/**
 * Wechselt zwischen SFN Beträgen und Stunden
 * @param {HTMLElement} thisElement 
 */
function toggleSFNResults(thisElement, event) {
	event.preventDefault();
	event.stopPropagation();
	if (typeof event.stopImmediatePropagation === 'function') {
		event.stopImmediatePropagation();
	}
	const details = thisElement.closest('details');
	if (thisElement.getAttribute('aria-label') == 'euro') {
		details.querySelectorAll('.result-an-sfn-std').forEach((elem) => elem.classList.remove('hidden'));
		details.querySelectorAll('.result-an-sfn-euro').forEach((elem) => elem.classList.add('hidden'));
		thisElement.setAttribute('aria-label', 'std');
	} else {
		details.querySelectorAll('.result-an-sfn-euro').forEach((elem) => elem.classList.remove('hidden'));
		details.querySelectorAll('.result-an-sfn-std').forEach((elem) => elem.classList.add('hidden'));
		thisElement.setAttribute('aria-label', 'euro');
	}
}

function nachrichtenButtonClick() {
	document.querySelector('#ma-filter-monatsinfo').value = 'ungeleseneMA';
	filterListe();
	// Sidebar toggle 
	if (document.body.clientWidth > 920) return;
	const sidebar = document.getElementById('sidebar');
	const sidebarToggle = document.getElementById('sidebar-toggle');
	const sidebarOverlay = document.getElementById('sidebar-overlay');
	sidebar.classList.toggle('open');
	sidebarOverlay.classList.toggle('open');
	sidebarToggle.setAttribute('aria-expanded', sidebar.classList.contains('open'));
}